import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";
import TrustBar from "../components/TrustBar";
import Counter from "../components/Counter"; // make sure this component exists
import {
  GasCylinderIcon,
  DeliveryTruckIcon,
  FlameIcon,
  ShieldIcon,
  InstallationIcon,
  StarIcon,
  CheckIcon,
} from "../components/icons";

const Home = () => {
  const [headlineIndex, setHeadlineIndex] = useState(0);
  const headlines = [
    "Zambia’s Trusted LPG Distributor",
    "Safe, Reliable, Affordable Gas Supply",
    "Official AFROX Handigas Partner",
    "10 Outlets Across Lusaka – Efficient Delivery!",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setHeadlineIndex((prev) => (prev + 1) % headlines.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const services = [
    {
      id: "sales",
      icon: <GasCylinderIcon />,
      title: "LPG Sales",
      description: "All cylinder sizes (6kg – 48kg)",
      details:
        "High‑quality AFROX Handigas LPG for home cooking, heating, and business.",
    },
    {
      id: "delivery",
      icon: <DeliveryTruckIcon />,
      title: "Efficient Delivery",
      description: "Door‑to‑door within Lusaka",
      details:
        "We deliver your gas within hours – orders before noon same‑day delivery for only K50 per cylinder.",
    },
    {
      id: "installation",
      icon: <InstallationIcon />,
      title: "Installation",
      description: "New LPG domestic products",
      details:
        "Expert installation of gas stoves, pipes, and regulators for new homes.",
    },
    {
      id: "bulk",
      icon: <FlameIcon />,
      title: "Bulk Supply",
      description: "Restaurants, hotels, industry",
      details:
        "Custom bulk LPG plans with dedicated tanks and regular refills.",
    },
    {
      id: "accessories",
      icon: <StarIcon />,
      title: "Accessories",
      description: "Stoves, pipes, regulators",
      details: "Complete range of gas cooking appliances and spare parts.",
    },
    {
      id: "safety",
      icon: <ShieldIcon />,
      title: "Safety Inspections",
      description: "Free safety checks",
      details: "We provide complimentary safety inspections for all customers.",
    },
  ];

  const trustItems = [
    {
      icon: <ShieldIcon />,
      title: "AFROX Certified",
      desc: "Trained & certified by AFROX Zambia",
    },
    {
      icon: <DeliveryTruckIcon />,
      title: "10 Outlets",
      desc: "Convenient locations across Lusaka",
    },
    {
      icon: <StarIcon />,
      title: "6+ Years",
      desc: "Proven track record since 2019",
    },
    {
      icon: <CheckIcon />,
      title: "1500+ Happy Clients/Month",
      desc: "Trusted by homes and businesses",
    },
  ];

  const partners = [
    {
      name: "AFROX Zambia",
      desc: "Exclusive LPG supplier & training partner",
      logo: "/images/partners/afrox.png",
    },
    {
      name: "FNB Zambia",
      desc: "Alliance partner – easy payments",
      logo: "/images/partners/fnb.png",
    },
    {
      name: "USAID",
      desc: "Grant recipient for clean cooking",
      logo: "/images/partners/usaid.png",
    },
    {
      name: "BETUZ",
      desc: "Expanding access to clean cooking solutions for teachers nationwide",
      logo: "/images/partners/betuz.png",
    },
  ];

  // Product preview data
  const previewProducts = [
    { name: "6kg Cylinder", image: "/images/products/6kg-gas.jpg" },
    { name: "9kg Cylinder", image: "/images/products/9kg-cylinder.png" },
    { name: "14kg Cylinder", image: "/images/products/14kg-gas.jpg" },
    { name: "19kg Cylinder", image: "/images/products/19kg-gas.png" },
    { name: "45kg Cylinder", image: "/images/products/48kg-gas.png" },
    { name: "2 Plate Gas Cooker", image: "/images/products/stove.png" },
  ];

  // Dynamic News Items
  const newsItems = [
    {
      id: 1,
      date: "May 20, 2026",
      category: "Partnership",
      title: "BETUZ & Tranquility Distributors Sign Clean Cooking MoU",
      excerpt:
        "A landmark agreement to bring affordable LPG to teachers across Zambia through the BETUZ national network.",
      image: "/images/news/betuz.png",
      content: (
        <>
          <p>
            The Basic Teachers Union of Zambia (BETUZ) is a nationally
            recognised teachers’ union representing educators primarily within
            the basic education subsector. Established to advance the
            professional, social, and economic welfare of its members, BETUZ
            operates across all provinces with an extensive grassroots presence
            in schools.
          </p>
          <p>
            <strong>Core Mandate</strong>
            <br />
            • Advocate for improved working conditions, remuneration, and
            professional development for teachers.
            <br />
            • Promote quality education standards and support government and
            sector reforms.
            <br />• Provide member services including welfare support, training,
            and administrative facilitation.
          </p>
          <p>
            The Memorandum of Understanding (MoU) between BETUZ and Tranquility
            Distributors Ltd establishes a structured partnership aimed at
            expanding access to clean cooking solutions for teachers nationwide.
            The agreement leverages BETUZ’s national membership network and
            Tranquility Distributors’ LPG distribution capacity to deliver an
            affordable, safe, and scalable LPG adoption programme.
          </p>
        </>
      ),
    },
    {
      id: 2,
      date: "May 27, 2026",
      category: "Partnership",
      title:
        "AFROX Managing Director Pays Courtesy Visit to Tranquility Distributors",
      excerpt:
        "AFROX MD Mr. Hendrix Munyinda and Northern Region Manager Mr. Victor Kapanda visited our offices, reaffirming commitment to safety standards and clean energy expansion across Zambia.",
      image: "/images/news/afrox-meeting.jpg",
      content: (
        <>
          <p>
            We were honoured to receive{" "}
            <strong>AFROX Managing Director, Mr. Hendrix Munyinda</strong>{" "}
            (standing left), and{" "}
            <strong>
              Regional Manager – Northern Region, Mr. Victor Kapanda
            </strong>{" "}
            (standing centre), during their courtesy visit to our offices today.
            Their engagement reaffirmed our mutual commitment to deepening
            strategic partnerships, upholding the highest safety standards, and
            advancing the expansion of clean energy access across Zambia.
          </p>

          <p>
            AFROX is a leading supplier of industrial and medical gases,
            including liquefied petroleum gas (LPG), with a strong footprint
            across Zambia. The company is renowned for its rigorous safety
            protocols, reliable supply chains, and commitment to promoting clean
            energy alternatives. This visit builds on a long-standing
            relationship between AFROX and Tranquility Distributors Ltd, focused
            on driving LPG adoption in residential and commercial markets.
          </p>

          <p>
            Discussions during the visit centred on collaborative initiatives to
            enhance LPG accessibility, improve safety training for distributors
            and end-users, and explore new models for reaching underserved
            communities. Both teams agreed to intensify joint efforts in
            supporting Zambia’s transition away from traditional biomass fuels,
            aligning with national environmental and health goals.
          </p>

          <p>
            The presence of senior AFROX leadership underscores the strategic
            importance of our partnership. We look forward to rolling out
            expanded clean cooking programmes and innovative distribution
            solutions in the coming months, with safety and customer empowerment
            at the core of every step.
          </p>
        </>
      ),
    },
    // add more news objects as needed
  ];

  return (
    <div className="home">
      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      >
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>{headlines[headlineIndex]}</h1>
          <p className="hero-subtitle">
            Tranquility Distributors – delivering clean, safe energy to homes,
            businesses, and industries.
          </p>
          <div className="hero-buttons">
            <Link to="/shop" className="btn btn-primary">
              Shop Now
            </Link>
            <Link
              to="/about"
              className="btn btn-outline"
              style={{ color: "white", borderColor: "white" }}
            >
              About Us
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Bar */}
      <TrustBar items={trustItems} />

      {/* Core Services */}
      <section className="section">
        <div className="container">
          <h2 className="section-title text-center">Our Services</h2>
          <p className="section-subtitle text-center">
            Everything you need for clean, safe cooking
          </p>
          <div className="services-grid">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
          <div className="text-center" style={{ marginTop: "2rem" }}>
            <Link to="/services" className="btn btn-primary">
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us section">
        <div className="container">
          <div className="why-content">
            <div className="why-image" />
            <div>
              <h2>Why Choose Tranquility Distributors?</h2>
              <ul className="why-list">
                <li>
                  <strong>Exclusive AFROX Handigas partner</strong> – guaranteed
                  quality
                </li>
                <li>
                  <strong>10 outlets</strong> for easy access across Lusaka
                </li>
                <li>
                  <strong>Efficient same‑day delivery</strong> on orders before
                  noon
                </li>
                <li>
                  <strong>Flexible payment options</strong> – cash, mobile
                  money, card
                </li>
                <li>
                  <strong>Trained & certified staff</strong> for safe handling
                </li>
                <li>
                  <strong>Competitive prices</strong> with no hidden fees
                </li>
                <li>
                  <strong>Environmentally friendly</strong> clean energy
                </li>
              </ul>
              <Link
                to="/about"
                className="btn btn-outline"
                style={{ marginTop: "1.5rem" }}
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Counter */}
      <section className="stats-section">
        <div className="container stats-grid">
          <div className="stat-item">
            <span className="stat-number">
              <Counter end={1500} />+
            </span>
            <span className="stat-label">Satisfied Clients Monthly</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">
              <Counter end={10} />
            </span>
            <span className="stat-label">Store Outlets</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">
              <Counter end={6} />+
            </span>
            <span className="stat-label">Years Experience</span>
          </div>
        </div>
      </section>

      {/* Product Preview */}
      <section className="section container">
        <h2 className="section-title text-center">Our Popular Products</h2>
        <div className="product-preview-grid">
          {previewProducts.map((prod, i) => (
            <div className="product-preview-item" key={i}>
              <img src={prod.image} alt={prod.name} />
              <h4>{prod.name}</h4>
            </div>
          ))}
        </div>
        <div className="text-center" style={{ marginTop: "2rem" }}>
          <Link to="/shop" className="btn btn-primary">
            View Full Catalogue
          </Link>
        </div>
      </section>

      {/* Partners / Clients */}
      <section className="section">
        <div className="container">
          <h2 className="section-title text-center">
            Trusted Partners & Collaborations
          </h2>
          <p className="section-subtitle text-center">
            Working with the best to bring you quality
          </p>
          <div className="clients-grid">
            {partners.map((client, index) => (
              <div key={index} className="client-card">
                <div className="client-image-container">
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="client-logo"
                  />
                  <div className="client-overlay">
                    <div className="client-overlay-content">
                      <h3>{client.name}</h3>
                      <p>{client.desc}</p>
                    </div>
                  </div>
                </div>
                <div className="client-info">
                  <h4>{client.name}</h4>
                  <p>{client.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety */}
      <section className="section safety-section">
        <div className="container">
          <h2 className="section-title text-center">Uncompromising Safety</h2>
          <p className="section-subtitle text-center">
            Your well‑being is our top priority
          </p>
          <div className="safety-grid">
            <div className="safety-item">
              <div className="safety-icon">
                <ShieldIcon />
              </div>
              <h3>Certified Handling</h3>
              <p>
                All staff trained by AFROX on safe gas handling and emergency
                procedures.
              </p>
            </div>
            <div className="safety-item">
              <div className="safety-icon">
                <CheckIcon />
              </div>
              <h3>Regular Inspections</h3>
              <p>We inspect cylinders and equipment at every delivery point.</p>
            </div>
            <div className="safety-item">
              <div className="safety-icon">
                <InstallationIcon />
              </div>
              <h3>Proper Installation</h3>
              <p>
                Expert fitting of regulators, pipes, and stoves to prevent
                leaks.
              </p>
            </div>
            <div className="safety-item">
              <div className="safety-icon">
                <FlameIcon />
              </div>
              <h3>Environmental Care</h3>
              <p>LPG is a clean‑burning fuel, reducing indoor air pollution.</p>
            </div>
          </div>
          <div className="text-center" style={{ marginTop: "2rem" }}>
            <Link to="/safety" className="btn btn-outline">
              Our Safety Commitment
            </Link>
          </div>
        </div>
      </section>

      {/* Latest News – Redesigned */}
      <section className="section news-section">
        <div className="container">
          <h2 className="section-title text-center">Latest News</h2>
          <p className="section-subtitle text-center">
            Stay updated with our recent activities and partnerships
          </p>
          <div className="news-grid">
            {newsItems.map((item) => (
              <article className="news-card" key={item.id}>
                <div className="news-card-image">
                  <img src={item.image} alt={item.title} />
                  <span className="news-category">{item.category}</span>
                </div>
                <div className="news-card-body">
                  <time className="news-date">{item.date}</time>
                  <h3 className="news-title">{item.title}</h3>
                  <p className="news-excerpt">{item.excerpt}</p>
                  <div className="news-content">{item.content}</div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="contact-cta">
        <div className="container">
          <h2>Ready to Experience Clean Energy?</h2>
          <p>
            Contact us today for a free quotation or visit any of our outlets.
          </p>
          <Link to="/contact" className="btn">
            Get in Touch
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
